import React, { useMemo } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../lotties/waiting-animation.json';
import { replaceColor } from 'lottie-colorify';
import { palette } from '../design-system/colors';

export function WaitingAnimation() {
    const defaultOptions = useMemo(
        () => ({
            loop: true,
            autoplay: true,
            animationData: replaceColor(
                palette.vibrant.raspberry,
                '#FFFFFF',
                animationData
            ),
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
            },
        }),
        []
    );

    return <Lottie options={defaultOptions} />;
}
